import { render, staticRenderFns } from "./SponsorResources.vue?vue&type=template&id=dd44ca90&scoped=true&"
import script from "./SponsorResources.vue?vue&type=script&lang=js&"
export * from "./SponsorResources.vue?vue&type=script&lang=js&"
import style0 from "./SponsorResources.vue?vue&type=style&index=0&id=dd44ca90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd44ca90",
  null
  
)

export default component.exports